<template>
    <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
            <b-card class="mb-0">
                <b-link class="brand-logo">
                    <b-img src="@/assets/images/logo/logo.png" alt="logo" class="logo-image" />
                    <h2 class="brand-text text-primary ml-1">
                        ObjectifEval
                    </h2>
                </b-link>





                <!-- Contenu de la carte -->
                <b-card-title class="mb-1">
                    Méthode de récupération de l'OTP
                </b-card-title>
                <b-card-text class="mb-1">
                    <b-form-radio-group v-model="selected" :options="options" class="demo-inline-spacing mb-1"
                        value-field="value" text-field="text" disabled-field="disabled" />
                </b-card-text>
                <!-- Formulaire -->
                <validation-observer ref="simpleRules">
                    <b-form class="auth-forgot-password-form mt-2" @submit.prevent="validationForm">
                        <!-- Champ d'e-mail -->
                        <b-form-group v-if="selected === 'EMAIL'" label-for="forgot-password-email">
                            <validation-provider #default="{ errors }" name="Email" rules="required|email">
                                <b-form-input id="forgot-password-email" v-model="identifier"
                                    :state="errors.length > 0 ? false : null" name="forgot-password-email"
                                    placeholder="objectifeval@sirat.bj" />
                                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                <small class="text-danger">{{ errors[0] ? `Le champ "Email" est requis.` : "" }}</small>

                            </validation-provider>
                        </b-form-group>
                        <!-- Champ de numéro de téléphone -->
                        <b-form-group v-if="selected === 'TELEPHONE'" label-for="telephoneInput">
                            <validation-provider #default="{ errors }" name="Téléphone" rules="required">
                                <b-form-input v-model="identifier" :state="errors.length > 0 ? false : null"
                                    placeholder="Téléphone" />
                            </validation-provider>
                        </b-form-group>
                        <!-- Bouton d'envoi -->
                        <b-button variant="primary" block type="submit">
                            Envoyer le code
                        </b-button>
                    </b-form>
                </validation-observer>
            </b-card>
        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BCard, BLink, BCardText, BCardTitle, BFormGroup, BForm, BButton, BFormInput, BFormRadioGroup, BImg,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { saveMethode } from '@/services/LoginService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { $themeConfig } from '@themeConfig'

export default {
    components: {
        BFormRadioGroup,
        BImg,
        BCard,
        BLink,
        BCardText,
        BCardTitle,
        BFormGroup,
        BFormInput,
        BButton,
        BForm,
        ValidationProvider,
        ValidationObserver,
        //eslint-disable-next-line vue/no-unused-components
        ToastificationContent,
    },
    data() {
        return {
            identifier: '', // Adresse e-mail ou numéro de téléphone
            selected: 'EMAIL', // Option sélectionnée
            // Validation
            required,
            email,
            options: [
                { text: 'E-mail', value: 'EMAIL', disabled: false },
                // { text: 'Téléphone', value: 'TELEPHONE', disabled: true },
            ],
        }
    },

    methods: {
        async validationForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    const methodData = { methode: this.selected, username: this.identifier };
                    saveMethode(methodData)
                        .then(response => {
                            if (response.code) {
                                localStorage.setItem('methodData', JSON.stringify(response));
                                this.$router.push({ name: 'login-opt' });
                            } else {
                                this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: 'Votre compte a été désactivé. ',
                                        icon: 'AlertCircleIcon',
                                        variant: 'danger',//warning
                                        timeout: 10000,
                                    },
                                })
                            }

                        })
                        .catch(error => {
                            console.error('Erreur lors de l\'enregistrement de la méthode:', error);
                        });
                }
            });
        },

    },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style>
.logo-image {
    height: 40px;
    /* Ajuste selon la taille souhaitée */
    margin-right: 1px;
}
</style>